import { render } from "./p-table.vue?vue&type=template&id=5375148d&scoped=true"
import script from "./p-table.vue?vue&type=script&lang=js"
export * from "./p-table.vue?vue&type=script&lang=js"

import "./p-table.vue?vue&type=style&index=0&id=5375148d&scoped=true&lang=scss"
import "./p-table.vue?vue&type=style&index=1&id=5375148d&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5375148d"]])

export default __exports__